const news = {
    'zh-tw': "最新消息", 
    en: "",
    children:{}
}
const news_type = {
    'zh-tw': "最新消息分類", 
    en: "",
    children:{}

}
const sigle_new = {
    'zh-tw': "消息", 
    en: "",
    children:{}

}
const language_utility = {
    news:{
        ...news
    },
    news_type:{
        ...news_type
    },
    new:{
        ...sigle_new
    }
}



export {
    language_utility
}